export enum StatutAttestation {
  NON_DEPOSEE = 'NON_DEPOSEE',
  DEPOSEE = 'DEPOSEE',
}